<template>
  <div v-loading="loader.visible" class="history-tab">
    <div v-for="(item, index) in history" :key="`${index}_${item.id}`">
      <div v-if="showDate(getDate(item.date_created), index)" class="time">
        <span>{{ getDate(item.date_created) }}</span>

        <Divider dividerSize="1" hasLine />
      </div>
      <SHistory :data="item" :module="module" />
    </div>

    <Alert v-if="!history.length && !requestSent" text="Истории еще нет" />
  </div>
</template>

<script>
const AUDIT_COUNT_CONFIG = 25;
import { getController } from '@/controllers/request.js';
import { store } from '@/store';
import { ACTION, MODULE } from '@/utils/constants';
import Alert from 'Elements/Alert/Alert';
import Divider from 'Elements/Divider/Divider';
import SHistory from 'Elements/History/History';

export default {
  props: {
    module: String,
    tabId: String
  },
  data() {
    return {
      mainComponent: null,
      audit_iteration: 1,
      loader: {
        visible: false,
        accept_scroll: false
      }
    };
  },
  mounted() {
    localStorage.removeItem('lastDate');
    setTimeout(() => {
      this.loader.accept_scroll = this.history.length === AUDIT_COUNT_CONFIG;
      this.mainComponent = this.getMainComponent();
      this.mainComponent.addEventListener('scroll', this.handleScroll);
    }, 200);
  },
  destroyed() {
    delete store.state.subpanels.activeSubpanelData.audit;
    this.mainComponent?.removeEventListener('scroll', this.handleScroll);
  },
  computed: {
    history: {
      get() {
        return store.state.subpanels.activeSubpanelData.audit;
      },
      set(val) {
        store.commit('subpanels/setActiveSubpanelData', {
          tabName: 'audit',
          data: val
        });
      }
    },
    requestSent: {
      get() {
        return store.state.common.requestSent;
      },
      set(val) {
        store.commit('common/setRequestState', val);
      }
    },
    isActiveSubpanel() {
      return Object.values(store.state.subpanels.activeSubpanel).some(
        tab => tab.id == this.tabId
      );
    }
  },
  methods: {
    getMainComponent() {
      switch (this.$router.history?.current?.meta?.module) {
        case MODULE.CANDIDATES_MODULE:
          return document.getElementsByClassName(
            'candidate-card__page scrollable-content'
          )[0];
        case MODULE.VACANCY_MODULE:
        case MODULE.COORDINATION_REQUEST:
        case MODULE.COORDINATION:
          return document.getElementById('pane-audit');
        default:
          return null;
      }
    },
    getAuditEntries() {
      this.requestSent = true;
      this.$emit('set-loading', true);
      getController({
        params: {
          module: MODULE.AUDIT,
          action: ACTION.POPUP,
          module_name: this.module,
          record: this.$router.history?.current?.params?.id,
          count: AUDIT_COUNT_CONFIG,
          iteration: this.audit_iteration
        }
      })
        .then(resp => {
          if (resp.data && !resp.data.error) {
            localStorage.removeItem('lastDate');
            this.history = [...this.history, ...resp.data];
            this.audit_iteration++;
            this.loader = {
              visible: false,
              accept_scroll: resp.data.length === AUDIT_COUNT_CONFIG
            };
            if (!this.history.length) return;

            this.$nextTick(() =>
              store.commit('vacancy/setParam', {
                name: 'activityDate',
                val: this.history[0].date_created.split(' ')[0]
              })
            );
          }
        })
        .catch(err => {
          console.error('error', err);
        })
        .finally(() => {
          this.requestSent = false;
          this.$emit('set-loading', false);
        });
    },
    handleScroll(e) {
      if (
        (e.target.scrollHeight <=
          Math.round(e.target.scrollTop + e.target.clientHeight) ||
          e.target.scrollHeight <=
            Math.round(e.target.scrollTop + e.target.clientHeight) + 1) &&
        this.loader.accept_scroll &&
        !this.requestSent
      ) {
        this.$set(this.loader, 'visible', true);
        this.getAuditEntries();
      }
    },
    getDate(datetime) {
      return datetime ? datetime.split(' ')[0] : '';
    },
    showDate: function (value) {
      let lastDate = localStorage.getItem('lastDate');
      if (lastDate === null || lastDate !== value) {
        localStorage.setItem('lastDate', value);
        lastDate = value;
        return true;
      }
      return false;
    }
  },
  components: {
    SHistory,
    Divider,
    Alert
  }
};
</script>

<style lang="scss" scoped>
.history-tab {
  padding: 24px;
  background: $white;
  // border-radius: 4px;

  .time {
    gap: 8px;
    display: flex;
    align-items: center;
    margin-bottom: 16px;

    span {
      font-size: 15px;
      line-height: 24px;
      font-family: 'Roboto Medium';
    }

    div {
      width: 100%;
      height: 1px;
      background: $grey8;
    }
  }
}
</style>
